import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { useOfferingAgePricingByPrice } from '@/hooks/api/useOfferingAgePricing'
import { Loader2, Users } from 'lucide-react'
import { AgePricingRangeForm } from './AgePricingRangeForm'

interface ViewAgePricingModalProps {
  offeringId: string
  priceId: string | null
  isOpen: boolean
  onClose: () => void
}

export const ViewAgePricingModal = ({ offeringId, priceId, isOpen, onClose }: ViewAgePricingModalProps) => {
  const { data: agePricing, isLoading } = useOfferingAgePricingByPrice(offeringId, priceId)

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[700px] max-h-[90vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Users className="h-5 w-5" />
            Precios por Edad (Historial)
          </DialogTitle>
        </DialogHeader>
        
        <div className="flex-1 overflow-y-auto pr-2">
          {isLoading ? (
            <div className="flex items-center justify-center py-12">
              <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
            </div>
          ) : agePricing ? (
            <div className="py-4">
              <AgePricingRangeForm 
                ranges={agePricing.ranges} 
                onChange={() => {}} 
                readOnly={true} 
              />
            </div>
          ) : (
            <div className="py-12 text-center text-muted-foreground italic">
              No se encontraron rangos de edad para este registro.
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
